<template>
  <div>
    <el-form
      ref="form"
      :rules="rulesEdit"
      :model="form"
      label-width="170px"
      :disabled="parentData.isDetail"
    >
      <el-row style="padding-right:80px;margin-top:40px;">
        <el-col :span="8">
          <el-form-item label="车队名称" prop="linkMan">
            <!-- 解决自动填充问题 -->
            <el-input
              v-model.trim="form.linkMan"
              placeholder="请输入车队名称"
              @keydown.native="channelInputLimit"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别" clearable>
              <el-option value="1" label="男"></el-option>
              <el-option value="2" label="女"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="联系人" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入联系人"
              @keydown.native="channelInputLimit"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系方式"
              autocomplete="off"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col v-if="isAdmin || dirverLeader" :span="8">
          <el-form-item label="是否清分" prop="isShare">
            <el-select v-model="form.isShare">
              <el-option
                v-for="item in isShareOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="密码" prop="password">
            <!-- 解决自动填充问题 -->
            <el-input
              type="password"
              style="position: fixed; bottom: -9999px"
            />
            <el-input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              placeholder="请输入密码，默认abcd1234"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            v-if="compIsShare && (isAdmin || dirverLeader)"
            label="清分比率(%)"
            prop="shareRatio"
          >
            <el-input
              v-model="form.shareRatio"
              placeholder="请输入0-100的正整数"
              @input="
                value =>
                  formFormatter.ishundredInteger(
                    value,
                    oldValue,
                    form,
                    'shareRatio'
                  )
              "
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="车队名称" prop="linkMan">

            <el-input v-model.trim="form.linkMan" placeholder="请输入车队名称" />
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="工作单位" prop="workCompany">
            <el-input v-model="form.workCompany" placeholder="请输入工作单位" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader
              v-model="form.areaList"
              placeholder="请选择通信地址"
              :options="parentData.areaOptions"
              :props="{
                value: 'countyCode',
                label: 'countyName',
                children: 'children'
              }"
              @change="changeAreaList"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="详细地址" prop="homeAddress">
            <el-input v-model="form.homeAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人代表名称" prop="legalPerson">
            <el-input
              v-model.trim="form.legalPerson"
              placeholder="请输入法人代表名称"
              @change="
                value => {
                  form.legalPerson = value.replace(/\s/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号" prop="identificationNumber">
            <el-input
              v-model="form.identificationNumber"
              placeholder="请输入身份证号"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证有效期" prop="idCardDueDate">
            <el-date-picker
              v-model="form.idCardDueDate"
              :class="form.hasDueDate ? 'disabledhide' : ''"
              type="date"
              placeholder="请选择身份证有效期"
              value-format="yyyy-MM-dd"
              clearable
              :disabled="form.hasDueDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item label="长期" label-width="60px">
            <el-checkbox
              v-model="form.hasDueDate"
              @change="
                value => {
                  this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路运输经营许可证号"
              @change="
                value => {
                  form.roadPermitNumber = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="统一社会信用代码" prop="businessLicenseNumber">
            <el-input
              v-model="form.businessLicenseNumber"
              placeholder="请输入统一社会信用代码"
              @change="
                value => {
                  form.businessLicenseNumber = value.replace(/\W/g, '');
                }
              "
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="允许实际承运人抢单" prop="allowDriverReceive">
            <el-select v-model="form.allowDriverReceive">
              <el-option
                v-for="item in allowDriverReceiveOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="!parentData.isDetail" :span="24">
          <el-form-item label="上传证件">
            <ImgUpload
              :upload-config="{
                lebal: '身份证人像面照片',
                prefix: 'identification',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.identificationImg"
              @handleImgSuccess="ficationImgSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '身份证国徽面照片',
                prefix: 'identificationBack',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.identificationBackImg"
              @handleImgSuccess="ficationImgBackSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '统一社会信用代码照片',
                prefix: 'businessLicense',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.businessLicenseImg"
              @handleImgSuccess="businessImgSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '道路运输经营许可证照片',
                prefix: 'roadPermitNumber',
                form: form,
                suffix: 'Img'
              }"
              :parent-data="parentData"
              :required="!!requireData.roadPermitNumberImg"
              @handleImgSuccess="roadPermitNumberSuccess"
            />
            <ImgUpload
              :upload-config="{
                lebal: '安全责任险照片',
                prefix: 'safeDutyInsure',
                form: form,
                suffix: 'Img'
              }"
              :required="!!requireData.safeDutyInsureImg"
              :parent-data="parentData"
            />
          </el-form-item>
        </el-col>
        <el-col v-else :span="24">
          <el-form-item label="上传证件">
            <ImgReview
              lebal="实际承运人身份证人像面照片"
              :src="form.identificationImg"
              error="未上传"
            />
            <ImgReview
              lebal="实际承运人身份证国徽面照片"
              :src="form.identificationBackImg"
              error="未上传"
            />
            <ImgReview
              lebal="统一社会信用代码照片"
              :src="form.businessLicenseImg"
              error="未上传"
            />
            <ImgReview
              lebal="道路运输经营许可证照片"
              :src="form.roadPermitNumberImg"
              error="未上传"
            />

            <ImgReview
              lebal="安全责任险照片"
              :src="form.safeDutyInsureImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button
      v-if="!parentData.isDetail"
      type="primary"
      plain
      @click="funcSubmit('form')"
    >
      提交
    </el-button>
  </div>
</template>
<script>
import { getDriverTeam, getDriverInfo, updateDriverTeam } from "@/api/driver";
import { validatePhone, validateIDNumber } from "@/utils/validate.js";
// import { isPositiveInteger } from "@/utils/validate4Form.js";
import {
  ishundredInteger,
  checkPassword,
  isBusinessLicenseImgNum
} from "@/utils/validate4Form.js";
// import {isBusinessLicenseImgNum,istenOrEighteen} from "@/utils/validate4Form.js";
import { findByFieldFrom } from "@/api/required";
import ImgUpload from "@/components/ImgUpload";
import ImgReview from "@/components/ImgReview";
import { getOcr } from "@/api/shipment";
import { realDay } from "@/utils/validate.js";
import { isPersonName } from "@/utils/validate4Form";
export default {
  // name: "DriverTeamEdit",
  components: {
    ImgUpload,
    ImgReview
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleBindList: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          locationSourceList: [],
          roadPermit: {
            roadPermitNumber: "",
            roadPermitNumberImg: ""
          }
        };
      }
    }
  },
  data() {
    return {
      form: {
        shareRatio: "",
        isShare: ""
      },
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 允许抢单
      allowDriverReceiveOptions: [
        { label: "允许", value: 0 },
        { label: "禁止", value: 1 }
      ],
      dirverLeader: "",
      // 必填功能
      isAdmin: false,
      requireData: {},
      rulesEdit: {
        areaList: [
          { required: false, message: "请选择所在区域", trigger: "change" }
        ],
        homeAddress: [
          { required: false, message: "请输入详细地址", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ],
        identificationNumber: [
          {
            required: false,
            message: "请输入身份证号",
            trigger: "blur"
          },
          {
            validator(rule, value, callback) {
              validateIDNumber(value)
                ? callback()
                : callback(new Error("请输入正确的身份证号"));
            },
            trigger: "blur"
          }
        ],
        idCardDueDate: [
          {
            required: false,
            message: "请选择身份证有效期",
            trigger: "change"
          }
        ],
        linkMan: [
          { required: false, message: "请输入车队名称", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" },
          { validator: isPersonName }
        ],
        name: [
          { required: false, message: "请输入联系人", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" },
          { validator: isPersonName }
        ],
        shareRatio: [
          { required: true, message: "请输入清分比率(%)", trigger: "blur" },
          { validator: ishundredInteger, trigger: "blur" }
        ],
        password: [
          { required: false, message: "请输入密码", trigger: "blur" },
          { validator: checkPassword }
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("请输入正确的联系方式"));
            },
            trigger: "blur"
          }
        ],
        businessLicenseNumber: [
          {
            required: false,
            message: "请输入统一社会信用代码",
            trigger: "blur"
          },
          { validator: isBusinessLicenseImgNum }
        ],

        roadPermitNumber: [
          {
            required: false,
            message: "请输入道路运输经营许可证号",
            trigger: "blur"
          },
          { max: 128, message: "最大长度为128个字符" }
        ],
        legalPerson: [
          { required: false, message: "请输入法人代表名称", trigger: "blur" },
          { max: 64, message: "最大长度为64个字符" }
        ],
        workCompany: [
          { required: false, message: "请输入工作单位", trigger: "blur" },
          { max: 255, message: "最大长度为255个字符" }
        ]
      }
    };
  },
  computed: {
    compIsShare() {
      return this.form.isShare == 1 ? true : false;
    }
  },
  watch: {
    // compIsShare(newValue, oldValue) {
    //   let Blen = !!newValue?false:!!this.requireData.roadPermitNumber
    //   this.rulesEdit.roadPermitNumber[0].required = Blen;
    //   this.rulesEdit.workCompany[0].required = Blen;
    //   this.rulesEdit.legalPerson[0].required = Blen;
    // }
    // 监听路由刷新
    $route: function(route) {
      if (route.query.code && route.path.indexOf("editDriverTeamForm") > -1) {
        this.getDriverTeam();
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.findByFieldFrom();
    this.form.code = this.$route.query.code ? this.$route.query.code : "";
    let roles = this.$store.getters.roles;
    this.dirverLeader = roles.indexOf("DRIVER_LEADER") > -1 ? true : false;
    if (this.form.code || this.isAdmin) {
      this.getDriverTeam();
    } else {
      // 车主
      getDriverInfo().then(response => {
        this.form = response.data;
        this.$set(this.form, "areaList", []);
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
      });
    }
  },

  methods: {
    findList() {},
    getDriverTeam() {
      getDriverTeam(this.form.code).then(response => {
        this.form = response.data;
        this.$set(this.form, "areaList", []);
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        // 是否清分
        this.$set(this.parentData, "isShare", this.form.isShare);
        if (this.form.roadPermitNumber) {
          this.$set(
            this.parentData.roadPermit,
            "roadPermitNumber",
            this.form.roadPermitNumber
          );
          this.$set(
            this.parentData.roadPermit,
            "roadPermitNumberImg",
            this.form.roadPermitNumberImg
          );
        }
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
      });
    },
    // 查询必填项
    async findByFieldFrom() {
      let response = await findByFieldFrom({ fieldFrom: "driverTeam" });
      this.requireData = response.data;
      for (let key in this.requireData) {
        if (this.rulesEdit[key])
          this.rulesEdit[key][0].required = !!this.requireData[key];
      }
      this.rulesEdit.password[0].required = false;
    },
    // 区域切换
    changeAreaList(value) {
      if (value.length > 0) {
        this.form.provinceCode = value[0];
        this.form.cityCode = value[1];
        this.form.countyCode = value[2];
      } else {
        this.form.provinceCode = "";
        this.form.cityCode = "";
        this.form.countyCode = "";
      }
    },
    // 提交
    funcSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          updateDriverTeam(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            if (this.$route.query.code) {
              this.$router.push({
                path: "/basicInfo/driver/driverTeamManage"
              });
            } else {
              getDriverInfo().then(response => {
                this.form = response.data;
                this.$set(this.form, "areaList", []);
                if (
                  this.form.provinceCode &&
                  this.form.cityCode &&
                  this.form.countyCode
                ) {
                  this.form.areaList.push(
                    this.form.provinceCode,
                    this.form.cityCode,
                    this.form.countyCode
                  );
                }
              });
            }
          });
        }
      });
    },
    channelInputLimit(e) {
      let key = e.key;
      // 只能输入中文、英文和·
      const reg = /[a-zA-Z\u4E00-\u9FA5·]/;
      if (!reg.test(key)) {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 身份证正面识别
    async ficationImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrIdidentityCardFront" });
      let data = res.data;
      data.name ? this.$set(this.form, "name", data.name) : null;
      data.name ? this.$set(this.form, "legalPerson", data.name) : null;
      data.identity
        ? this.$set(this.form, "identificationNumber", data.identity)
        : null;
      data.address ? this.$set(this.form, "homeAddress", data.address) : null;
      if (data.provinceCode) {
        this.$set(this.form, "provinceCode", data.provinceCode);
        this.$set(this.form, "cityCode", data.cityCode);
        this.$set(this.form, "countyCode", data.countyCode);
        this.$set(this.form, "areaList", [
          data.provinceCode,
          data.cityCode,
          data.countyCode
        ]);
      }
    },
    // 身份证反面识别
    async ficationImgBackSuccess(url) {
      let res = await getOcr({
        image: url,
        ocrType: "ocrIdidentityCardFrontBack"
      });
      let data = res.data;
      if (data.expiryDate == "长期" || data.expiryDate == "9999-12-31") {
        this.$set(this.form, "hasDueDate", true);
        this.$set(this.form, "idCardDueDate", "9999-12-31");
      } else if (data.expiryDate) {
        let time = data.expiryDate.replace(/[^\d]/g, "");
        if (realDay(time)) {
          let expiryDate =
            time.slice(0, 4) + "-" + time.slice(4, 6) + "-" + time.slice(6);
          this.$set(this.form, "idCardDueDate", expiryDate);
          this.$set(this.form, "hasDueDate", false);
        }
      }
    },
    // 道路经营许可证识别
    async roadPermitNumberSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrRoadPermitNumber" });
      let data = res.data;
      data.hao ? this.$set(this.form, "roadPermitNumber", data.hao) : null;
    },
    // 社会信用识别
    async businessImgSuccess(url) {
      let res = await getOcr({ image: url, ocrType: "ocrBusinessLicense" });
      let data = res.data;
      if (data.creditNum !== "无") {
        this.$set(this.form, "businessLicenseNumber", data.creditNum);
      }
      if (data.companyName !== "无") {
        this.$set(this.form, "workCompany", data.companyName);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 100%;
}
</style>
